









import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import VueRouter from "vue-router";
import Sling from "@/classes/Sling";

@Component({
    components: {},
})
export default class Home extends Vue {
    table: { [key: string]: string }[] = [];

    mounted() {
        const sling = new Sling();

        const table: { [key: string]: string }[] = [];

        const targetWeightCode = "1";
        const targetNumberCode = "2";
        const wireCode = "1";

        sling.targetWeightCode = targetWeightCode;
        sling.targetNumberCode = targetNumberCode;
        sling.wireCode = wireCode;

        for (const wireLengthCode in sling.wireLengths) {
            sling.wireLengthCode = wireLengthCode;

            for (const ringCode in sling.ringSpecs) {
                sling.ringCode = ringCode;

                const row: { [key: string]: string } = {};
                row["targetWeight"] = String(sling.targetWeight);
                row["targetNumber"] = String(sling.targetNumber);
                row["diameter"] = String(sling.diameter);
                row["wire"] = String(sling.wire);
                row["wireLength"] = String(sling.wireLength);
                row["ringLength"] = String(sling.ringLength);
                table.push(row);
            }
        }

        this.table = table;
    }
}
